import { useAPI } from "@humansignal/core";
import { IconFolderAdd } from "@humansignal/icons";
import { Button } from "@humansignal/ui";
import { useEffect, useState } from "react";
import { plural } from "./shared";
import "./Datasets.prefix.css";

/**
 * Project header button: put this project's data in a dataset (a new one,
 * or one it already feeds), then open the dataset. Shown only while the
 * project has data that is in no dataset yet: tasks made from a dataset,
 * and what a dataset already took, do not count.
 */
export const SaveAsDataset = ({ project, canManage }) => {
  const api = useAPI();
  const [fresh, setFresh] = useState(0);
  const wanted = canManage && project?.id && project.task_number > 0;

  useEffect(() => {
    if (!wanted) return setFresh(0);
    let alive = true;
    api.callApi("projectDatasetStatus", { params: { pk: project.id }, errorFilter: () => true }).then((res) => {
      if (alive) setFresh(res?.new ?? 0);
    });
    return () => {
      alive = false;
    };
  }, [api, wanted, project?.id, project?.task_number, project?.total_annotations_number]);

  if (!wanted || fresh < 1) return null;
  // The dialog is loaded when asked for: it uses the platform's dialog
  // parts, which the package entry must not pull in.
  const open = async () => {
    const { openAddData } = await import("./AddData");
    openAddData({ project, onDone: (dataset) => window.location.assign(`/datasets/${dataset.id}`) });
  };
  return (
    <Button
      size="small"
      look="outlined"
      onClick={open}
      // The words would crowd a toolbar: the icon carries it, and what
      // it does is in the tooltip with how much is waiting.
      icon={<IconFolderAdd />}
      tooltip={`Save as dataset: ${plural(fresh, "item is", "items are")} in no dataset yet`}
      aria-label="Save this project's data as a dataset"
      data-testid="save-as-dataset"
      className="lsf-save-as-dataset"
    />
  );
};
